// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2549":"d0461727ad531a21e8a8","3469":"fe2f2c3e1beff0963e4d"}[chunkId] + ".js";
};